<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 10v4a1 1 0 0 0 1 1h2l1.5 6h2L8 15h2l9 4V6l-9 4H4a1 1 0 0 0-1 1Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 9.5v5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
</svg>
</template>
